export default {
  data() {
    return {
      downloadText: this.$translate('APP_TEXT').replace(
        'PARTNERNAAM',
        this.$store.getters['Account/partnerGroupDetails']
          .PartnerGroupDisplayName
      ),
    };
  },
  computed: {
    pgDetails() {
      const result = this.$store.getters['Account/partnerGroupDetails'];
      if (result == null) {
        return {};
      }
      return result;
    },
    hasAppsImplemented() {
      const appleApp = this.pgDetails.AppleStoreListingUrl || '';
      const playStoreApp = this.pgDetails.GoogleStoreListingUrl || '';
      // check if both apps have url links
      return appleApp !== '' && playStoreApp !== '';
    },
    currentOS() {
      // this checks what type of phone the user is using
      if (/Android/i.test(navigator.userAgent)) {
        return 'Android';
      }
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return 'iOS';
      }
      return 'unknown';
    },
    appStoreUrl() {
      if (
        this.pgDetails.AppleStoreListingUrl == null ||
        this.pgDetails.AppleStoreListingUrl === ''
      ) {
        return '';
      }
      return this.pgDetails.AppleStoreListingUrl;
    },
    playStoreUrl() {
      if (
        this.pgDetails.GoogleStoreListingUrl == null ||
        this.pgDetails.GoogleStoreListingUrl === ''
      ) {
        return '';
      }
      return this.pgDetails.GoogleStoreListingUrl;
    },
    downloadPictureWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '70%';
        case 'sm':
          return '40%';
        case 'md':
          return '80%';
        case 'lg':
        case 'xl':
        default:
          return '60%';
      }
    },
  },
};
